import api from "@core/api/api";

/**
 * Fetch badge numbers for sidebar indicators
 * @returns {Promise<Object>} Badge numbers data
 */
export const fetchBadgeNumbers = async () => {
  const response = await api.get("/statistics/badge-numbers");
  return response.data.data;
};

/**
 * Fetch overview statistics
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Overview statistics data
 */
export const fetchOverview = async (params) => {
  const response = await api.get("/statistics/overview", { params });
  return response.data.data;
};

export default {
  fetchBadgeNumbers,
  fetchOverview,
};
